import api, { buildQueryString } from "./client";

// API 엔드포인트 상수
const API_ENDPOINT_PREFIX = "/api/v1/menus";

// 메뉴 관리 API
export const menuAPI = {
  // 내 메뉴 목록 조회
  getMyMenus: async (config = {}) => {
    try {
      const response = await api.get(`${API_ENDPOINT_PREFIX}/my-menus`, config);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 메뉴 검색
  getMenuSearch: async ({ params = {}, config = {} } = {}) => {
    try {
      const response = await api.post(
        `${API_ENDPOINT_PREFIX}/search`,
        params,
        config
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 메뉴 검색
  searchMenusAsTree: async ({ params = {}, config = {} } = {}) => {
    try {
      const response = await api.post(
        `${API_ENDPOINT_PREFIX}/search/tree`,
        params,
        config
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 메뉴 목록 조회 (관리용)
  getMenus: async ({ params = {}, config = {} } = {}) => {
    try {
      const response = await api.get(
        `${API_ENDPOINT_PREFIX}${buildQueryString(params)}`,
        config
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 메뉴 트리 조회
  getMenuTree: async ({ params = {}, config = {} } = {}) => {
    try {
      const response = await api.get(
        `${API_ENDPOINT_PREFIX}/tree${buildQueryString(params)}`,
        config
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 메뉴 상세 조회
  getMenu: async (menuId) => {
    try {
      const response = await api.get(`${API_ENDPOINT_PREFIX}/${menuId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 메뉴 생성
  createMenu: async (menuData) => {
    try {
      const response = await api.post(API_ENDPOINT_PREFIX, menuData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 메뉴 수정
  updateMenu: async (menuId, menuData) => {
    try {
      const response = await api.put(
        `${API_ENDPOINT_PREFIX}/${menuId}`,
        menuData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 메뉴 삭제
  deleteMenu: async (menuId, { config = {} } = {}) => {
    try {
      const response = await api.delete(
        `${API_ENDPOINT_PREFIX}/${menuId}`,
        config
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 메뉴 순서 변경
  updateMenuOrder: async (menuOrderData) => {
    try {
      const response = await api.put(
        `${API_ENDPOINT_PREFIX}/order`,
        menuOrderData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 메뉴별 사용자 조회
  getMenuUsers: async (menuId, { params = {}, config = {} } = {}) => {
    try {
      const response = await api.get(
        `${API_ENDPOINT_PREFIX}/${menuId}/users`,
        config
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 메뉴에 사용자 추가
  addMenuUsers: async (menuId, userData) => {
    try {
      const response = await api.post(
        `${API_ENDPOINT_PREFIX}/${menuId}/users`,
        userData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 메뉴에서 사용자 제거
  removeMenuUsers: async (menuId, userData) => {
    try {
      const response = await api.post(
        `${API_ENDPOINT_PREFIX}/${menuId}/users/remove`,
        userData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 부모 메뉴 목록 조회 (메뉴 생성/수정 시 사용)
  getParentMenus: async (menuId, { params = {}, config = {} } = {}) => {
    try {
      const response = await api.get(
        `${API_ENDPOINT_PREFIX}/${menuId}/parent${buildQueryString(params)}`,
        config
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default menuAPI;
